{
  "common": {
    "ok": "OK",
    "cancel": "Cancelar",
    "save": "Salvar",
    "delete": "Excluir",
    "edit": "Editar",
    "close": "Fechar",
    "loading": "Carregando...",
    "error": "Erro",
    "info": "Informação",
    "success": "Sucesso",
    "back": "Voltar",
    "send": "Enviar",
    "sending": "Enviando...",
    "search": "Pesquisar",
    "accept": "Aceitar",
    "reject": "Rejeitar",
    "confirm": "Confirmar",
    "online": "Em linha",
    "you": "Tu",
    "noMessages": "Sem mensagens ainda",
    "adminPanelDesktopOnly": "Painel indisponível no telemóvel",
    "adminPanelDesktopOnlyHint": "Os painéis de administração e organizador estão disponíveis em tablet e computador.",
    "networkError": "Não foi possível carregar os dados.",
    "networkErrorHint": "Verifique a sua conexão e tente novamente.",
    "retry": "Tentar novamente",
    "myQrCode": "Meu código QR",
    "myQrPill": "Meu QR",
    "hideQrPill": "Ocultar Meu QR",
    "showQrPill": "Mostrar Meu QR",
    "today": "Hoje",
    "tomorrow": "Amanhã"
  },
  "auth": {
    "login": {
      "title": "Bem-vindo de volta!",
      "subtitle": "Iniciar sessão",
      "credentialsHint": "Introduza as suas credenciais para continuar",
      "email": "Email",
      "emailPlaceholder": "teu@email.com",
      "password": "Palavra-passe",
      "passwordPlaceholder": "••••••••",
      "loading": "A iniciar sessão...",
      "button": "Iniciar sessão",
      "forgotPassword": "Esqueceste a palavra-passe?",
      "forgotPasswordSoon": "Em breve",
      "forgotPasswordMessage": "A recuperação de palavra-passe estará disponível em breve.",
      "continueWith": "ou continua com",
      "noAccount": "Não tens conta?",
      "createAccount": "Criar conta",
      "errors": {
        "emailNotConfirmed": "Não foi possível iniciar sessão.\n\nSe acabaste de criar a conta, tenta novamente dentro de alguns segundos.",
        "loginError": "Erro ao iniciar sessão",
        "unexpectedError": "Ocorreu um erro inesperado. Por favor, tenta novamente."
      }
    },
    "register": {
      "title": "Junta-te à BIAVENT!",
      "subtitle": "Criar Conta",
      "email": "Email",
      "emailPlaceholder": "teu@email.com",
      "password": "Palavra-passe",
      "confirmPassword": "Confirmar Palavra-passe",
      "loading": "A criar conta...",
      "button": "Criar Conta",
      "continueWith": "ou continua com",
      "hasAccount": "Já tens conta?",
      "loginLink": "Iniciar sessão",
      "success": {
        "title": "✅ Conta criada com sucesso!",
        "message": "Já podes entrar. Vamos completar o teu perfil."
      },
      "errors": {
        "createError": "Erro ao criar conta",
        "unexpectedError": "Erro inesperado"
      }
    },
    "logout": {
      "button": "Terminar sessão",
      "confirm": "Tens a certeza de que queres terminar sessão?"
    },
    "forgotPassword": {
      "title": "Recuperação de palavra-passe",
      "subtitle": "Repor palavra-passe",
      "description": "Introduz o teu email e enviaremos um link para repores a palavra-passe.",
      "email": "Email",
      "emailPlaceholder": "teu@email.com",
      "loading": "A enviar...",
      "button": "Enviar link",
      "backToLogin": "Voltar ao início de sessão",
      "success": {
        "title": "Verifica o teu email",
        "message": "Se existir uma conta com esse email, receberás um link para repor a palavra-passe."
      },
      "errors": {
        "unexpectedError": "Ocorreu um erro inesperado. Por favor, tenta novamente."
      }
    },
    "resetPassword": {
      "title": "Nova palavra-passe",
      "subtitle": "Escolhe uma nova palavra-passe",
      "description": "Introduz e confirma a nova palavra-passe.",
      "password": "Nova palavra-passe",
      "passwordPlaceholder": "••••••••",
      "confirmPassword": "Confirmar palavra-passe",
      "confirmPasswordPlaceholder": "••••••••",
      "loading": "A atualizar...",
      "button": "Atualizar palavra-passe",
      "backToLogin": "Voltar ao início de sessão",
      "requirements": {
        "minLength": "Mínimo 8 caracteres",
        "lowercase": "Pelo menos uma minúscula",
        "uppercase": "Pelo menos uma maiúscula",
        "number": "Pelo menos um número",
        "symbol": "Pelo menos um símbolo"
      },
      "success": {
        "title": "Palavra-passe atualizada",
        "message": "A tua palavra-passe foi atualizada com sucesso."
      },
      "invalidLink": {
        "title": "Link inválido ou expirado",
        "message": "Este link de recuperação é inválido ou expirou. Solicita um novo.",
        "cta": "Solicitar novo link"
      },
      "errors": {
        "unexpectedError": "Ocorreu um erro inesperado. Por favor, tenta novamente."
      }
    }
  },
  "onboarding": {
    "personalInfo": {
      "title": "Informação pessoal",
      "subtitle": "Completa o teu perfil básico",
      "firstName": "Nome",
      "lastName": "Apelido",
      "phone": "Telefone",
      "email": "Email",
      "placeholderFirstName": "O teu nome",
      "placeholderLastName": "O teu apelido",
      "placeholderPhone": "+34 600 000 000",
      "placeholderEmail": "teu@email.com",
      "continue": "Continuar",
      "errorFirstName": "O nome é obrigatório",
      "errorLastName": "O apelido é obrigatório",
      "errorPhone": "Por favor, introduz um número de telefone válido",
      "errorEmail": "Por favor, introduz um email válido"
    },
    "socialNetworks": {
      "title": "Redes Sociais (Escolhe uma ou várias)",
      "linkedin": "LinkedIn",
      "instagram": "Instagram",
      "twitter": "X (Twitter)",
      "youtube": "YouTube",
      "tiktok": "TikTok",
      "placeholderLinkedin": "https://linkedin.com/in/teu-perfil",
      "placeholderInstagram": "https://instagram.com/teu-usuario",
      "placeholderTwitter": "https://twitter.com/teu-usuario",
      "placeholderYoutube": "https://youtube.com/@teu-canal",
      "placeholderTiktok": "https://tiktok.com/@teu-usuario",
      "errorInvalid": "Por favor, introduce uma URL válida"
    },
    "welcomeQuestion": {
      "title": "A que te dedicas?",
      "subtitle": "A tua resposta ajudará a gerar palavras-chave de networking e a sugerir-te conexões relevantes dentro do evento.",
      "placeholder": "Ex: Sou programador frontend, trabalho em marketing digital, sou empreendedor...",
      "continue": "Continuar",
      "back": "Voltar",
      "loading": "A processar...",
      "error": "Não conseguimos processar a tua resposta. Tenta novamente.",
      "errorEmpty": "Escreve algo sobre ti para continuar"
    }
  },
  "appTour": {
    "replayButton": "Ver tutorial novamente",
    "welcome": {
      "title": "Bem-vindo ao Biavent!",
      "subtitle": "Um tour rápido pelo essencial para começar.",
      "start": "Começar tour",
      "skip": "Saltar por agora"
    },
    "controls": {
      "prev": "Anterior",
      "next": "Seguinte",
      "skip": "Saltar tutorial",
      "close": "Fechar",
      "done": "Concluir",
      "progress": "{{current}} de {{total}}",
      "tapHere": "Toque aqui"
    },
    "steps": {
      "navOverview": {
        "title": "Navegação",
        "body": "Acede às secções principais da app a partir daqui."
      },
      "eventsHome": {
        "title": "Os teus eventos",
        "body": "Vê eventos próximos e a tua boas-vindas personalizada."
      },
      "eventsDiscover": {
        "title": "Explorar eventos",
        "body": "Aqui aparecem todos os eventos."
      },
      "navNetworking": {
        "title": "Networking",
        "body": "Toca aqui para ir a ligações e chats."
      },
      "networkingHub": {
        "title": "Atividade e ligações",
        "body": "Gere pedidos, contactos e conversas."
      },
      "navProfile": {
        "title": "O teu perfil",
        "body": "Toca para ver e editar o teu perfil profissional."
      },
      "profileComplete": {
        "title": "Perfil completo",
        "body": "Quanto mais completares o teu perfil, melhores recomendações te podemos oferecer."
      },
      "qrEssential": {
        "title": "O teu código QR",
        "body": "Mostra o QR nos eventos para ligar de imediato."
      }
    }
  },
  "settings": {
    "title": "Configurações",
    "subtitle": "Gerencie suas preferências",
    "appearance": {
      "title": "Aparência",
      "theme": {
        "label": "Tema",
        "auto": "Automático (como o dispositivo)",
        "light": "Claro",
        "dark": "Escuro",
        "description": "Escolha como deseja que o aplicativo apareça"
      }
    },
    "language": {
      "title": "Idioma",
      "label": "Idioma",
      "auto": "Automático (de acordo com o dispositivo)",
      "description": "Escolha o idioma do aplicativo",
      "detected": "Detetado"
    },
    "appTour": {
      "title": "Tutorial da app",
      "description": "Revê o tour guiado pelas funções principais.",
      "replay": "Ver tutorial novamente"
    },
    "notifications": {
      "title": "Notificações",
      "subtitle": "Gerencie suas preferências de notificações push"
    },
    "dataAndCache": {
      "title": "Dados e cache",
      "description": "Atualize os dados em cache ou recarregue o aplicativo para ver as informações mais recentes ou resolver problemas de carregamento.",
      "refreshData": "Atualizar dados",
      "clearAndReload": "Limpar cache e recarregar",
      "refreshSuccess": "Cache limpa. Os novos dados serão carregados ao navegar.",
      "reloading": "Recarregando..."
    }
  },
  "events": {
    "title": "Eventos",
    "greeting": "Olá",
    "upcomingEvent": "evento próximo",
    "upcomingEvents": "eventos próximos",
    "noUpcoming": "Não há eventos próximos",
    "recommendationHint": "Para receber recomendações personalizadas de participantes, inscreva-se nos eventos que lhe interessam.",
    "recommendationHintShort": "Inscreva-se em eventos para receber recomendações personalizadas.",
    "loading": "Carregando eventos...",
    "hidePast": "Ocultar eventos passados",
    "showPast": "Ver eventos passados",
    "noEvents": "Não há eventos",
    "noEventsMessage": "Por agora não há eventos programados. Volte em breve para descobrir novas oportunidades de conexão e aprendizagem.",
    "live": "EM DIRETO",
    "registered": "Inscrito",
    "full": "Completo",
    "register": "Registar",
    "sectionUpcoming": "Próximos eventos",
    "sectionPast": "Eventos passados",
    "filterAll": "Todos",
    "filterRegistered": "Registado",
    "filterPast": "Passados",
    "upcomingBadge": "Próximo",
    "participants": {
      "zero": "0 participantes",
      "one": "1 participante",
      "many": "{count} participantes"
    },
    "capacity": {
      "full": "Esgotado ({max}/{max})",
      "oneLeft": "{current}/{max} vagas (1 disponível)",
      "available": "{current}/{max} vagas ({available} disponíveis)"
    }
  },
  "eventDetail": {
    "loading": "A carregar evento...",
    "notFound": "Evento não encontrado",
    "backToEvents": "Voltar aos eventos",
    "back": "Voltar",
    "live": "EM DIRETO",
    "description": "Descrição",
    "registration": {
      "title": "Inscrição",
      "subtitle": "Reserva o teu lugar e recebe toda a informação necessária para participar.",
      "full": "Evento completo ({max}/{max} lugares)",
      "capacity": "{count}/{max} lugares ocupados ({available} disponíveis)",
      "limitedSeats": "Lugares limitados: confirma a tua presença para garantir o teu lugar.",
      "pastEvent": "Este evento já se realizou. Consulta o calendário para novos encontros.",
      "alreadyRegistered": "Já estás inscrito e receberás as novidades do evento.",
      "unregisterLoading": "A cancelar inscrição...",
      "unregister": "Desinscrever-me do evento",
      "eventFull": "Este evento está completo. Não há lugares disponíveis.",
      "registerLoading": "A guardar o teu lugar...",
      "registerButton": "Inscrever-me no evento",
      "checkingRegistration": "A verificar se já estás inscrito...",
      "loadingProfile": "A carregar o teu perfil para ativar a inscrição...",
      "registeredTitle": "Estás inscrito!",
      "registeredEmailHint": "Enviaremos todas as informações por email"
    },
    "registrationGoal": {
      "title": "Qual é o seu objetivo neste evento?",
      "subtitle": "Conte-nos o que procura em \"{eventTitle}\" para recomendarmos pessoas com interesses alinhados.",
      "placeholder": "Ex.: Fazer networking com desenvolvedores, procurar investidores, aprender novas tecnologias...",
      "submit": "Inscrever-me e calcular matches ✨",
      "saveObjective": "Guardar objetivo ✨",
      "profileSaveError": "Não foi possível guardar o seu objetivo. Tente novamente.",
      "error": "Escreva um objetivo para o ajudar a conectar melhor.",
      "tagsTitle": "Sugestões rápidas (pode escolher várias):",
      "tag1": "🤝 Encontrar sócios ou colaboradores",
      "tag2": "💼 Procurar oportunidades de negócio",
      "tag3": "✨ Fazer networking e contactos",
      "tag4": "📚 Aprender e adquirir conhecimentos",
      "tag5": "🚀 Conhecer pessoas do setor"
    },
    "tabs": {
      "agenda": "Agenda",
      "speakers": "Oradores",
      "recommendations": "Recomendações",
      "notifications": "Notificações",
      "location": "Localização"
    },
    "agenda": {
      "title": "Agenda",
      "noAgenda": "Não há agenda disponível para este evento."
    },
    "speakers": {
      "title": "Oradores",
      "noSpeakers": "Não há oradores registados para este evento."
    },
    "recommendations": {
      "recommended": "Recomendados",
      "allAttendees": "Todos os participantes",
      "title": "Pessoas Recomendadas",
      "subtitle": "Pessoas inscritas no evento que te podem interessar.",
      "calculating": "A calcular recomendações...",
      "noRecommendations": "Não há recomendações disponíveis de momento.",
      "attendeesTitle": "Participantes do evento",
      "attendeesSubtitle": "Pessoas que já confirmaram a sua participação.",
      "loadingAttendees": "A carregar participantes...",
      "beFirst": "Sê a primeira pessoa a inscrever-se no evento.",
      "connect": "Conectar",
      "requestSent": "Pedido enviado",
      "openChat": "Abrir chat"
    },
    "notifications": {
      "title": "Notificações do Evento",
      "loading": "A carregar notificações...",
      "noNotifications": "Não há notificações para este evento.",
      "noNotificationsHint": "As notificações relacionadas com este evento aparecerão aqui.",
      "now": "Agora",
      "minutesAgo": "Há {mins} min",
      "hoursAgo": "Há {hours} h",
      "daysAgo": "Há {days} d",
      "eventNotification": "Notificação do evento",
      "noMessage": "Sem mensagem",
      "new": "Nova",
      "markAsRead": "Marcar como lida"
    },
    "location": {
      "title": "Localização",
      "openInMaps": "Abrir no Google Maps",
      "notAvailable": "Localização não disponível",
      "howToArrive": "Como queres chegar?",
      "byCar": "De carro",
      "byTransit": "Transportes públicos",
      "byBicycle": "De bicicleta",
      "byWalking": "A pé",
      "gettingLocation": "A obter a tua localização...",
      "cantCalculate": "Não é possível calcular a rota sem uma localização válida."
    },
    "errors": {
      "profileNotFound": "Não conseguimos identificar o teu perfil. Recarrega a página e tenta novamente.",
      "registrationFailed": "Não conseguimos completar a tua inscrição. Tenta novamente em alguns segundos.",
      "registrationError": "Ocorreu um erro ao registar a tua presença. Por favor, tenta mais tarde.",
      "unregisterConfirm": "Tens a certeza de que queres desinscrever-te deste evento?",
      "unregisterFailed": "Não conseguimos cancelar a tua inscrição. Tenta novamente em alguns segundos.",
      "unregisterError": "Ocorreu um erro ao cancelar a tua inscrição. Por favor, tenta mais tarde.",
      "geolocationNotSupported": "Geolocalização não suportada",
      "locationNotAvailable": "Localização não disponível",
      "locationAccessDenied": "Não conseguimos aceder à tua localização. A abrir Maps com o destino do evento.",
      "directionsError": "Ocorreu um erro ao abrir as direções.",
      "loadAttendeesError": "Não conseguimos carregar os participantes confirmados."
    },
    "readMore": "Ler mais",
    "readLess": "Ver menos",
    "spotsRemaining": "{count} vagas restantes"
  },
  "calendar": {
    "confirmationTitle": "Inscrição concluída!",
    "confirmationSubtitle": "Esperamos por ti em {eventTitle}",
    "addToGoogleCalendar": "Adicionar ao Google Calendar",
    "addToAppleCalendar": "Adicionar ao Apple Calendar",
    "addToCalendar": "Adicionar ao calendário",
    "hint": "Isto adicionará o evento ao teu calendário. Podes editá-lo depois.",
    "downloadICS": "Descarregar ficheiro .ics"
  },
  "profile": {
    "loading": "A carregar perfil...",
    "editPhoto": "Editar foto de perfil",
    "avatarUpdateError": "Não foi possível guardar a foto de perfil. Tenta novamente.",
    "avatarUploadError": "Não foi possível carregar a foto. Tenta novamente.",
    "avatarCropTitle": "Ajuste a sua foto",
    "avatarCropHint": "Arraste e use o zoom para encaixar o rosto dentro do círculo.",
    "avatarCropZoom": "Zoom",
    "avatarCropCancel": "Cancelar",
    "avatarCropSave": "Usar foto",
    "avatarCropError": "Não foi possível recortar a imagem. Tenta novamente.",
    "avatarCropInvalidType": "Seleciona um ficheiro de imagem válido.",
    "roles": {
      "admin": "Administrador",
      "user": "Utilizador"
    },
    "experience": {
      "beginner": "Principiante",
      "intermediate": "Intermédio",
      "advanced": "Avançado",
      "expert": "Perito"
    },
    "whoAmI": {
      "student": "Estudante",
      "professional": "Profissional",
      "entrepreneur": "Empreendedor",
      "investor": "Investidor",
      "mentor": "Mentor",
      "other": "Outro"
    },
    "goals": {
      "networking": "Networking",
      "learn": "Aprender",
      "opportunities": "Oportunidades",
      "mentorship": "Mentoria",
      "collaborate": "Colaborar",
      "share": "Partilhar",
      "personalBrand": "Marca Pessoal",
      "explore": "Explorar"
    },
    "tabs": {
      "aboutMe": "Sobre Mim",
      "networking": "Networking",
      "info": "Informação",
      "interests": "Interesses",
      "social": "Redes Sociais"
    },
    "completeness": {
      "label": "Perfil completo",
      "subtitle": "Completa o teu perfil para receber melhores sugestões de networking.",
      "matchHint": "Perfis com mais informação recebem melhores matches de networking.",
      "completeProfile": "Completar perfil",
      "completeNext": "Completar",
      "allDone": "Perfil completo! Receberás os melhores matches.",
      "personalInfo": "Informação pessoal",
      "interests": "Interesses",
      "eventObjective": "Objetivo no evento",
      "socialNetworks": "Redes sociais",
      "professionalExperience": "Experiência profissional",
      "bio": "Bio",
      "networkingLevel": "Nível Networking",
      "hint_personal_info": "Adiciona o teu nome e apelido",
      "hint_interests": "Adiciona os teus interesses profissionais",
      "hint_event_objective": "Indica o teu objetivo no evento",
      "hint_social_networks": "Adiciona pelo menos uma rede social",
      "hint_professional_experience": "Indica o teu papel e nível de experiência",
      "hint_bio": "Adiciona uma bio breve sobre ti"
    },
    "networking": {
      "title": "Networking",
      "seeking": "Procuro conectar com",
      "seekingTagInputPlaceholder": "Digite o tipo de pessoas que deseja conhecer e pressione Enter (ex. fundadores, investidores, desenvolvedores)",
      "offering": "O que ofereço",
      "offeringTagInputPlaceholder": "Digite o que pode oferecer e pressione Enter (ex. mentoria, colaboração, contratação)",
      "eventObjective": "Objetivo no evento",
      "bioShort": "Bio (máx 200 caracteres)",
      "bioShortPlaceholder": "Ex: Founder building AI products. Interested in meeting developers and investors.",
      "professionalKeywords": "Tags profissionais",
      "seeking_investors": "Investidores",
      "seeking_founders": "Fundadores",
      "seeking_developers": "Desenvolvedores",
      "seeking_designers": "Designers",
      "seeking_marketing": "Marketing",
      "seeking_product_managers": "Product Managers",
      "offering_mentorship": "Mentoria",
      "offering_investment": "Investimento",
      "offering_collaboration": "Colaboração",
      "offering_hiring": "Contratar talento",
      "offering_finding_partners": "Encontrar parceiros",
      "offering_sharing_knowledge": "Compartilhar conhecimento",
      "eventObjective_networking": "Networking",
      "eventObjective_finding_partners": "Encontrar parceiros",
      "eventObjective_finding_clients": "Encontrar clientes",
      "eventObjective_investment": "Investimento",
      "eventObjective_learning": "Aprender",
      "eventObjective_recruiting": "Recrutar talento"
    },
    "matchScore": {
      "title": "O teu perfil gera matches com",
      "subtitle": "Completa o teu perfil para melhorar as sugestões.",
      "empty": "Completa a secção Networking para ver compatibilidades.",
      "developersAI": "Desenvolvedores IA",
      "foundersSaaS": "Fundadores SaaS",
      "investors": "Investidores",
      "developers": "Desenvolvedores",
      "designers": "Designers",
      "marketing": "Marketing",
      "productManagers": "Product Managers",
      "fintech": "Fintech / Blockchain"
    },
    "aboutMe": {
      "title": "Sobre Mim",
      "edit": "Editar",
      "biography": "Biografia",
      "biographyPlaceholder": "Descreve brevemente o que fazes e com quem gostarias de te conectar (ex. Founder a construir produtos de IA, interessado em conhecer desenvolvedores e investidores).",
      "cancel": "Cancelar",
      "save": "Guardar",
      "noBio": "Adiciona uma bio curta para que outros participantes percebam rapidamente quem és.",
      "addBio": "Adicionar bio",
      "whatIDo": "O Que Faço",
      "noWhatIDo": "Completa esta secção para que outros saibam o que fazes.",
      "role": "Função",
      "experience": "Experiência",
      "goals": "Objetivos",
      "preferences": "Preferências"
    },
    "personalInfo": {
      "title": "Informação Pessoal",
      "edit": "Editar",
      "firstName": "Nome",
      "lastName": "Apelido",
      "birthDate": "Data de Nascimento",
      "phone": "Telefone",
      "email": "Email",
      "systemRole": "Função no Sistema",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "address": {
      "title": "Morada",
      "edit": "Editar",
      "city": "Cidade",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "interests": {
      "title": "Interesses",
      "edit": "Editar",
      "placeholder": "Inovação, Startups, Design...",
      "tagInputPlaceholder": "Digite um interesse e pressione Enter (ex. IA, Startups, Design)",
      "label": "Interesses",
      "cancel": "Cancelar",
      "save": "Guardar",
      "general": "Interesses Gerais",
      "onboarding": "Interesses do Onboarding",
      "noInterests": "Ainda não adicionaste interesses."
    },
    "social": {
      "title": "Redes Sociais",
      "edit": "Editar",
      "linkedin": "LinkedIn",
      "linkedinPlaceholder": "https://linkedin.com/in/usuario",
      "twitter": "X (Twitter)",
      "twitterPlaceholder": "https://twitter.com/usuario",
      "instagram": "Instagram",
      "instagramPlaceholder": "https://instagram.com/usuario",
      "github": "GitHub",
      "githubPlaceholder": "https://github.com/usuario",
      "facebook": "Facebook",
      "facebookPlaceholder": "https://facebook.com/usuario",
      "youtube": "YouTube",
      "youtubePlaceholder": "https://youtube.com/canal",
      "tiktok": "TikTok",
      "tiktokPlaceholder": "https://tiktok.com/@usuario",
      "website": "Site Web",
      "websitePlaceholder": "https://meu-site.com",
      "cancel": "Cancelar",
      "save": "Guardar",
      "noSocial": "Ainda não adicionaste redes sociais.",
      "emptyHint": "Adiciona as tuas redes para que outros participantes possam conhecer-te melhor.",
      "addSocialNetworks": "Adicionar redes sociais"
    },
    "errors": {
      "noChanges": "Não há alterações para guardar.",
      "updateError": "Erro: Não foi possível atualizar o perfil. Tenta novamente.",
      "saveError": "Erro: Ocorreu um erro ao guardar o perfil. Tenta novamente.",
      "avatarError": "Erro ao atualizar o avatar"
    }
  },
  "votacion": {
    "title": "Ajude-nos!",
    "subtitle": "Sua opinião é muito valiosa para nós. Compartilhe suas sugestões, ideias e comentários para nos ajudar a melhorar.",
    "form": {
      "loading": "Carregando formulário...",
      "eventLabel": "Selecione o evento",
      "foundErrorsLabel": "Você encontrou erros?",
      "yes": "Sim",
      "no": "Não",
      "errorDetailsLabel": "Se sim, quais?",
      "errorDetailsPlaceholder": "Conte quais erros você encontrou para que possamos corrigir.",
      "commentLabel": "Algo que você queira comentar sobre o evento? (opcional)",
      "commentPlaceholder": "Pode ser uma crítica construtiva, sua opinião sobre o evento ou qualquer outro comentário.",
      "submit": "Enviar feedback",
      "submitting": "Enviando feedback..."
    },
    "messages": {
      "profileError": "Não conseguimos carregar seu perfil. Tente novamente.",
      "selectEventRequired": "Selecione um evento para continuar.",
      "selectErrorsRequired": "Informe se encontrou erros.",
      "errorDetailsRequired": "Conte quais erros você encontrou.",
      "submitError": "Não foi possível enviar seu feedback. Tente novamente.",
      "submitSuccess": "Obrigado por nos ajudar a melhorar. Seu feedback foi enviado com sucesso.",
      "noEligibleEvents": "Você ainda não tem eventos disponíveis para avaliar.",
      "alreadySentForEvent": "Você já enviou feedback para este evento.",
      "pickAnotherEvent": "Se quiser, escolha outro evento para enviar mais feedback."
    }
  },
  "admin": {
    "title": "Administración",
    "eventos": "Eventos",
    "usuarios": "Usuarios",
    "organizaciones": "Empresas",
    "permisos": "Permisos",
    "rankings": "Rankings",
    "encuentros": "Encontros",
    "informes": "Informes y Métricas",
    "notificaciones": "Notificaciones",
    "dashboard": "Dashboard",
    "dashboardTitle": "Dashboard",
    "dashboardSubtitle": "Resumo global da plataforma",
    "dashboardKpiEvents": "Total de eventos",
    "dashboardKpiUsers": "Total de utilizadores",
    "dashboardKpiOrganizations": "Empresas",
    "dashboardKpiUpcoming": "Eventos próximos",
    "dashboardKpiPublished": "Publicados",
    "dashboardKpiDraft": "Rascunhos",
    "dashboardKpiPast": "Terminados",
    "dashboardKpiCancelled": "Cancelados",
    "dashboardUpcomingEvents": "Eventos próximos",
    "dashboardQuickActions": "Ações rápidas",
    "dashboardViewEvents": "Ver eventos",
    "dashboardViewUsers": "Ver utilizadores",
    "dashboardViewOrganizations": "Ver empresas",
    "dashboardViewReports": "Ver relatórios",
    "dashboardViewNotifications": "Ver notificações",
    "dashboardNewEvent": "Novo evento",
    "dashboardNoUpcoming": "Sem eventos próximos",
    "dashboardEventDate": "Data",
    "dashboardLoading": "A carregar resumo...",
    "nuevoEvento": "Nuevo Evento",
    "organizacionesTitle": "Empresas",
    "organizacionesSubtitle": "Gerir as empresas da plataforma",
    "permisosTitle": "Permisos de organizador",
    "permisosSubtitle": "Atribua ou remova o papel de organizador e associe utilizadores a empresas",
    "crearOrganizacion": "Criar empresa",
    "crearOrganizacionHint": "A empresa será criada com o seu utilizador como proprietário e organizador.",
    "asignarOrganizador": "Asignar como organizador",
    "seleccionarOrganizacion": "Selecionar empresa",
    "sinOrganizacionesPermisos": "Crie uma empresa no separador Empresas para poder atribuir.",
    "quitarOrganizador": "Quitar rol organizador",
    "asociarAOrganizacion": "Asociar a organización",
    "nombreOrganizacion": "Nombre",
    "miembros": "Miembros",
    "propietario": "Propietario",
    "sinOrganizaciones": "Sem empresas",
    "gestionarPermisos": "Gerir permissões",
    "gestionarEquipo": "Gerir equipa",
    "equipoTitle": "Equipa de «{name}»",
    "equipoDescription": "Adicione utilizadores a esta empresa. Cada utilizador só pode pertencer a uma empresa.",
    "equipoEmpty": "Sem membros nesta empresa",
    "equipoSelectUser": "Selecionar utilizador",
    "equipoSearchUser": "Pesquisar por nome ou email…",
    "equipoSearchMin": "Escreve pelo menos 2 caracteres",
    "equipoSearchEmpty": "Nenhum utilizador encontrado",
    "equipoClearSelection": "Limpar seleção",
    "equipoAdd": "Adicionar à equipa",
    "rolOrganizador": "Organizador",
    "rolMiembro": "Membro",
    "quitarMiembro": "Remover",
    "panelScreens": "Ecrãs do painel",
    "panelScreensTitle": "Ecrãs visíveis no painel do organizador",
    "panelScreensDescription": "Ative ou desative as secções que os organizadores desta empresa verão.",
    "panelScreenDashboard": "Dashboard",
    "panelScreenEvents": "Eventos",
    "panelScreenAttendees": "Participantes",
    "panelScreenNetworking": "Networking",
    "panelScreenAnalytics": "Analytics",
    "panelScreenNotifications": "Notificações",
    "panelScreenSettings": "Definições da organização",
    "eliminarEmpresa": "Eliminar empresa",
    "confirmarEliminarEmpresa": "Eliminar empresa",
    "confirmarEliminarEmpresaHint": "Eliminar a empresa «{name}»? Os membros serão removidos e os eventos ficarão sem empresa atribuída.",
    "panelScreensSave": "Guardar ecrãs",
    "panelScreensAll": "Todas",
    "eventosSubtitle": "Gere todos os eventos da plataforma",
    "usuariosSubtitle": "Administre utilizadores e permissões",
    "rankingsSubtitle": "Rankings de utilizadores por conexões e atividade",
    "encuentrosSubtitle": "Encontros presenciais confirmados por QR entre utilizadores ligados",
    "meetups": {
      "loading": "A carregar encontros…",
      "kpiTotal": "Total confirmados",
      "kpi24h": "Últimas 24 h",
      "kpi7d": "Últimos 7 dias",
      "searchPlaceholder": "Pesquisar por nome ou email…",
      "empty": "Ainda não há encontros confirmados por QR",
      "emptyHint": "Quando dois utilizadores confirmarem um encontro presencial, aparecerá aqui.",
      "noSearchResults": "Sem resultados",
      "noSearchResultsHint": "Tenta outro nome ou email.",
      "colUserA": "Utilizador A",
      "colUserB": "Utilizador B",
      "colDate": "Data",
      "colMethod": "Método",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "informesSubtitle": "Métricas em tempo real para eventos futuros e relatórios completos para passados",
    "notificacionesSubtitle": "Envie notificações a todos os utilizadores ou a utilizadores selecionados",
    "filterOptions": "Opções de filtro",
    "filterAll": "Todos",
    "filterUpcoming": "Próximos",
    "filterPast": "Passados",
    "filterCancelled": "Cancelados",
    "filterAdmins": "Administradores",
    "filterUsers": "Utilizadores",
    "rankingByConnections": "Por conexões totais",
    "rankingMostConnected": "Mais conectados",
    "rankingByConnectionsTitle": "Ranking por conexões",
    "rankingMostConnectedTitle": "Utilizadores mais conectados",
    "rankingType": "Tipo de ranking",
    "tableTitle": "Título",
    "tableDate": "Data",
    "tableLocation": "Localização",
    "tableStatus": "Estado",
    "tableActions": "Ações",
    "tableName": "Nome",
    "tableEmail": "Email",
    "tableRole": "Função",
    "tableOrganizer": "Organizador",
    "tablePosition": "Posição",
    "tableSent": "Enviados",
    "tableReceived": "Recebidos",
    "tableAccepted": "Aceites",
    "tableTotal": "Total",
    "tableConnections": "Conexões",
    "tableUser": "Utilizador",
    "statusUpcoming": "Próximo",
    "statusPast": "Passado",
    "statusCancelled": "Cancelado",
    "roleAdmin": "Admin",
    "roleUser": "Utilizador",
    "loading": "A carregar...",
    "loadingEvents": "A carregar eventos...",
    "loadingUsers": "A carregar utilizadores...",
    "loadingRankings": "A carregar rankings...",
    "noEvents": "Sem eventos",
    "noUsers": "Sem utilizadores",
    "noRankings": "Sem dados de rankings disponíveis",
    "makeAdmin": "Tornar Admin",
    "removeAdmin": "Remover Admin",
    "eventsCount": "Eventos",
    "usersCount": "Utilizadores",
    "confirmDeleteEvent": "Tem a certeza de que deseja eliminar o evento \"{title}\"? Esta ação não pode ser desfeita.",
    "roleUpdated": "Função atualizada com sucesso",
    "roleUpdateError": "Não foi possível atualizar a função",
    "eventDeleted": "Evento eliminado com sucesso",
    "eventDeleteError": "Não foi possível eliminar o evento",
    "orgCreated": "Organização criada com sucesso",
    "orgCreateError": "Não foi possível criar a organização",
    "dashboardTodayBanner": "{count} eventos comienzan HOY",
    "dashboardPlatformHealth": "Salud de Plataforma",
    "dashboardHealthNewUsers": "Usuarios nuevos (7 días)",
    "dashboardHealthPublishedEvents": "Eventos publicados",
    "dashboardHealthNewOrgs": "Empresas nuevas (7 días)",
    "dashboardDraftPastSummary": "{draft} borradores · {past} finalizados",
    "dashboardBadgeLive": "EN VIVO",
    "dashboardBadgeScheduled": "PROGRAMADO",
    "dashboardViewAllUpcoming": "Ver todos ({count}) →",
    "dashboardNewOrganization": "Nueva Empresa",
    "dashboardViewPermissions": "Ver Permisos"
  },
  "organizer": {
    "title": "Painel do organizador",
    "dashboard": "Dashboard",
    "events": "Eventos",
    "attendees": "Participantes",
    "networking": "Networking",
    "analytics": "Analytics",
    "notifications": "Notificações",
    "settings": "Configurações da organização",
    "loading": "A carregar...",
    "selectEvent": "Selecionar um evento",
    "noData": "Sem dados",
    "noDataDescription": "Não foi possível carregar os dados.",
    "dashboardTitle": "Dashboard",
    "dashboardDescription": "Resumo dos seus eventos e métricas. Selecione uma secção do menu para começar.",
    "dashboardLoading": "Carregando resumo...",
    "dashboardKpiTotalEvents": "Total de eventos",
    "dashboardKpiDraft": "Rascunhos",
    "dashboardKpiPublished": "Publicados",
    "dashboardKpiPast": "Finalizados",
    "dashboardKpiCancelled": "Cancelados",
    "dashboardKpiTotalAttendees": "Participantes registados",
    "dashboardKpiTotalActiveAttendees": "Participantes ativos",
    "dashboardNoPublishedHint": "Ainda não tens eventos publicados. Publica um para ver métricas.",
    "dashboardKpiTotalConnections": "Conexões geradas",
    "dashboardKpiTotalMessages": "Mensagens enviadas",
    "dashboardKpiAvgConnections": "Conexões por evento (média)",
    "dashboardKpiAvgProfile": "Perfil completo (média)",
    "dashboardUpcomingEvents": "Próximos eventos",
    "dashboardNoUpcoming": "Sem próximos eventos",
    "dashboardNoUpcomingDescription": "Publica um evento para que apareça aqui.",
    "dashboardTopNetworking": "Eventos com mais networking",
    "dashboardTopNetworkingConnections": "conexões",
    "dashboardNoNetworking": "Sem dados de networking",
    "dashboardNoNetworkingDescription": "Quando os teus eventos gerarem conexões, aparecerão aqui.",
    "dashboardCreateEvent": "Criar evento",
    "dashboardViewAnalytics": "Ver analytics",
    "dashboardViewEvents": "Ver eventos",
    "dashboardEmptyTitle": "Ainda não tens eventos",
    "dashboardEmptyDescription": "Cria o teu primeiro evento para começar a ver métricas e estatísticas.",
    "dashboardEventDate": "Data",
    "dashboardEventAttendees": "participantes",
    "eventsTitle": "Eventos",
    "eventsNew": "Novo evento",
    "eventsFilterStatus": "Estado:",
    "eventsFilterAll": "Todos",
    "eventsFilterPublished": "Publicados",
    "eventsFilterDraft": "Rascunho",
    "eventsFilterPast": "Passados",
    "eventsFilterCancelled": "Cancelados",
    "eventsFilterUpcoming": "Próximos",
    "eventsFilterDate": "Data:",
    "eventsTableLocation": "Localização",
    "eventsStatusPublished": "Publicado",
    "eventsStatusDraft": "Rascunho",
    "eventsStatusArchived": "Arquivado",
    "eventsStatusCancelled": "Cancelado",
    "eventsTableTitle": "Título",
    "eventsTableDate": "Data",
    "eventsTableStatus": "Estado",
    "eventsTableCapacity": "Capacidade",
    "eventsTableActions": "Ações",
    "eventsEdit": "Editar",
    "eventsCopyLink": "Copiar link",
    "eventsLinkCopied": "Link copiado",
    "eventsLanding": "Landing",
    "eventsPublish": "Publicar",
    "eventsUnpublish": "Despublicar",
    "eventsArchive": "Arquivar",
    "eventsCancel": "Cancelar evento",
    "eventsNoEvents": "Sem eventos",
    "eventsNoEventsDescription": "Crie o seu primeiro evento para começar.",
    "eventsNoCapacity": "Sem limite",
    "eventNewTitle": "Novo evento",
    "eventNewNoOrg": "Precisa pertencer a uma organização para criar eventos. Crie uma organização primeiro ou peça para ser adicionado como org_admin.",
    "eventNewBackToEvents": "Voltar a Eventos",
    "eventEditTitle": "Editar evento",
    "attendeesTitle": "Participantes",
    "attendeesSendNotification": "Enviar notificação",
    "attendeesNoAttendees": "Sem participantes",
    "attendeesNoAttendeesDescription": "Ainda não há inscritos neste evento.",
    "attendeesLoading": "A carregar participantes...",
    "attendeesTableName": "Nome",
    "attendeesTableEmail": "Email",
    "attendeesTableStatus": "Estado",
    "attendeesTableDate": "Data de registo",
    "attendeesTableProfile": "Perfil",
    "networkingTitle": "Networking",
    "networkingLoading": "A carregar métricas...",
    "networkingSentRequests": "Pedidos enviados",
    "networkingAcceptedRequests": "Pedidos aceites",
    "networkingTotalConnections": "Conexões totais",
    "networkingAcceptanceRatio": "Taxa de aceitação",
    "networkingTopConnectors": "Top conectores",
    "networkingNoData": "Sem dados",
    "networkingNoDataDescription": "Ainda não há conexões entre participantes.",
    "networkingNoDataGeneric": "Não foi possível carregar as métricas.",
    "networkingConnections": "conexões",
    "networkingAttendeesCount": "Participantes inscritos",
    "networkingHintLowEngagement": "Só parte dos participantes gerou conexões.",
    "networkingHintCta": "Envia uma notificação para incentivar o networking",
    "analyticsTitle": "Analytics",
    "analyticsLoading": "A carregar analytics...",
    "analyticsRegistered": "Registados",
    "analyticsActive": "Ativos",
    "analyticsActiveHelp": "Inscritos marcados como «a assistir» (check-in durante o evento)",
    "analyticsTotalAttendedHelp": "Inscritos marcados como «assistiram» após o evento",
    "analyticsRegisteredHelp": "Apenas quem clicou em «Inscrever-se» no evento na app (não todos os utilizadores com conta)",
    "analyticsProfileComplete": "% Perfil completo",
    "analyticsSentRequests": "Pedidos enviados",
    "analyticsAcceptedRequests": "Pedidos aceites",
    "analyticsTotalConnections": "Conexões totais",
    "analyticsAcceptanceRatio": "Taxa de aceitação",
    "analyticsMessagesSent": "Mensagens enviadas",
    "analyticsActiveConversations": "Conversas ativas",
    "analyticsActiveConversationsHelp": "Chats com pelo menos uma mensagem (DMs entre participantes + chat do evento)",
    "analyticsConnectionsPerAttendee": "Conexões por participante (média)",
    "analyticsFunnel": "Funil",
    "analyticsRegistrationsByDay": "Registos por dia",
    "analyticsDate": "Data",
    "analyticsRegistrations": "Registos",
    "analyticsTopInterests": "Top interesses",
    "analyticsTopGoals": "Top objetivos",
    "analyticsShareableSummary": "Resumo partilhável",
    "meetups": {
      "sectionTitle": "Encontros confirmados",
      "kpiTotal": "Total",
      "kpi24h": "Últimas 24 h",
      "kpi7d": "Últimos 7 dias",
      "empty": "Sem encontros confirmados",
      "emptyHint": "Aqui aparecem os encontros presenciais confirmados pelos participantes deste evento ao lerem o QR de uso único.",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "analyticsCopyClipboard": "Copiar para a área de transferência",
    "analyticsCopied": "Copiado",
    "analyticsNoData": "Sem dados",
    "analyticsNoDataDescription": "Não foi possível carregar as métricas para este evento.",
    "analyticsFilterAll": "Todos",
    "analyticsFilterUpcoming": "Próximos",
    "analyticsFilterPast": "Finalizados",
    "analyticsEventHeaderViewEvent": "Ver evento",
    "analyticsEventHeaderCopyLink": "Copiar link",
    "analyticsEventHeaderViewAttendees": "Ver participantes",
    "analyticsEventHeaderSendNotification": "Enviar notificação",
    "analyticsStatusUpcoming": "Próximo",
    "analyticsStatusOngoing": "Em curso",
    "analyticsStatusPast": "Finalizado",
    "analyticsStatusCancelled": "Cancelado",
    "analyticsSectionAttendance": "Presença e registo",
    "analyticsSectionNetworking": "Networking e participação",
    "analyticsSectionFunnel": "Funil de participação",
    "analyticsSectionSummary": "Resumo partilhável",
    "analyticsLastUpdate": "Última atualização",
    "analyticsEmptyNoEvents": "Ainda não tens eventos",
    "analyticsEmptyNoEventsDescription": "Cria o teu primeiro evento para ver analíticas.",
    "analyticsEmptyNoRegistrations": "Ainda não há inscritos neste evento.",
    "analyticsEmptyNoNetworkingTitle": "Sem atividade de networking ainda",
    "analyticsEmptyNoNetworkingCta": "Envia uma notificação para ativar o networking entre participantes.",
    "analyticsMetricUnavailable": "Sem dados ainda",
    "analyticsCopySummary": "Copiar resumo",
    "analyticsFunnelRegistered": "Registados",
    "analyticsFunnelProfileComplete": "Perfil completo",
    "analyticsFunnelSentRequest": "Enviaram pedido",
    "analyticsFunnelConnected": "Conectados",
    "analyticsFunnelChatted": "Conversaram",
    "analyticsTotalRegistered": "Total registados",
    "analyticsTotalAttended": "Total presentes",
    "analyticsAttendanceRate": "Taxa de presença",
    "analyticsCancelled": "Cancelados",
    "analyticsSelectEventPlaceholder": "Selecionar evento",
    "analyticsEmptySelectEvent": "Seleciona um evento para ver as métricas",
    "notificationsTitle": "Notificações",
    "notificationsSendToAttendees": "Enviar aos participantes do evento",
    "notificationsTitlePlaceholder": "Título",
    "notificationsMessagePlaceholder": "Mensagem",
    "notificationsSend": "Enviar",
    "notificationsSending": "A enviar...",
    "notificationsHistory": "Histórico de campanhas",
    "notificationsNoCampaigns": "Sem campanhas",
    "notificationsNoCampaignsDescription": "Ainda não enviou notificações para este evento.",
    "settingsPageTitle": "Configurações",
    "settingsOrgSection": "Organização",
    "settingsOrgName": "Nome da organização",
    "settingsTeamSection": "Equipa",
    "settingsTeamRoleAdmin": "Administrador",
    "settingsTeamRoleMember": "Membro",
    "settingsTeamRemove": "Remover da equipa",
    "settingsRemoveConfirm": "Remover este utilizador da equipa?",
    "settingsTeamOwner": "proprietário",
    "settingsTableName": "Nome",
    "settingsTableEmail": "Email",
    "settingsTableRole": "Função",
    "settingsSave": "Guardar",
    "settingsSaved": "Guardado",
    "settingsLoading": "A carregar…",
    "settingsNoOrg": "Não tem nenhuma organização. Crie uma a partir do painel de administração.",
    "brandingSectionTitle": "Company branding",
    "brandingSectionDesc": "Logo and colors applied to your organization's events.",
    "brandingLogoLabel": "Logo",
    "brandingLogoHint": "Drag an image or click (max. 2 MB)",
    "brandingLogoUpload": "Upload logo",
    "brandingLogoRemove": "Remove logo",
    "brandingUploading": "Uploading…",
    "brandingPrimary": "Primary color",
    "brandingSecondary": "Secondary color",
    "brandingContrastWarning": "Secondary color may have low contrast with white text on badges.",
    "brandingPreviewLabel": "Live preview",
    "brandingSaved": "Branding saved",
    "brandingSaveError": "Could not save branding",
    "brandingUploadError": "Failed to upload logo",
    "plataforma": "Plataforma",
    "dashboardKpiRegistered": "Inscritos totales",
    "dashboardKpiAttendance": "Asistencia",
    "dashboardKpiEngagement": "Engagement",
    "dashboardTrendThisWeek": "esta semana",
    "dashboardNextActions": "Próximas acciones",
    "dashboardActionEventsWeek": "{count} eventos comienzan esta semana",
    "dashboardActionPendingCheckIn": "{count} inscritos sin check-in confirmado",
    "dashboardActionConnections": "Revisa las nuevas conexiones en Networking",
    "dashboardMyEvents": "Mis eventos",
    "dashboardAttendeesShort": "inscritos",
    "dashboardBadgeLive": "EN DIRECTO",
    "dashboardBadgeScheduled": "Programado",
    "dashboardQuickActionsTitle": "Acciones",
    "dashboardViewAttendees": "Ver asistentes",
    "dashboardSendNotification": "Enviar notificación",
    "dashboardQuickAnalytics": "Analytics rápido",
    "dashboardExportCsv": "Exportar CSV",
    "dashboardCreateEventShort": "+ Create event",
    "dashboardViewAllEvents": "View all ({count})"
  },
  "panel": {
    "title": "Painel",
    "admin": "Painel de administração",
    "organizer": "Painel do organizador",
    "desktopOnly": {
      "title": "Disponível em tablet e computador",
      "description": "Os painéis de administração e organizador são pensados para ecrãs maiores. Abre esta página num tablet ou computador.",
      "backToEvents": "Voltar aos eventos"
    }
  },
  "navigation": {
    "eventos": "Eventos",
    "chats": "Chats",
    "perfil": "Perfil",
    "ajustes": "Configurações",
    "votacion": "Ajude-nos!",
    "quienesSomos": "Sobre Nós",
    "actividad": "Atividade",
    "closeMenu": "Fechar menu",
    "panel": "Painel",
    "panelAdmin": "Painel de administração",
    "panelOrganizer": "Painel do organizador"
  },
  "chats": {
    "title": "Chats",
    "activity": {
      "feedTitle": "Atividade",
      "feedSubtitle": "Pedidos, mensagens e conexões",
      "markAllRead": "Marcar tudo como lido",
      "error": "Não foi possível carregar a atividade.",
      "retry": "Tentar novamente",
      "empty": "Ainda não tens atividade",
      "emptyHint": "Pedidos de conexão, aceites e mensagens aparecerão aqui.",
      "exploreEvents": "Explorar eventos",
      "someone": "Alguém",
      "newMessage": "Nova mensagem",
      "sentRequest": "enviou-te um pedido",
      "requestSent": "Pedido enviado",
      "requestAccepted": "aceitou o teu pedido"
    },
    "recentActivity": "A tua atividade recente",
    "loading": "A carregar...",
    "noChats": "Ainda não tens chats",
    "noChatsHint": "Regista-te num evento para poderes conectar e falar com mais pessoas",
    "tabs": {
      "activity": "Atividade",
      "connections": "Conexões",
      "chats": "Chats"
    },
    "requests": {
      "title": "Pedidos",
      "allContacts": "Todos os teus contactos",
      "favorites": "Favoritos",
      "sent": {
        "title": "Pedidos Enviados",
        "pending": "pedido pendente",
        "pendingPlural": "pedidos pendentes",
        "waiting": "À espera de resposta",
        "cancel": "Cancelar"
      },
      "received": {
        "title": "Pedidos de Conexão",
        "pending": "pedido pendente",
        "pendingPlural": "pedidos pendentes",
        "wantsToConnect": "Quer conectar contigo",
        "accept": "Aceitar",
        "reject": "Rejeitar",
        "noPending": "Sem pedidos pendentes"
      }
    },
    "contacts": {
      "noContacts": "Não tens contactos conectados",
      "noContactsHint": "Conecta com outros utilizadores para os veres aqui",
      "removeFavorite": "Remover dos favoritos",
      "addFavorite": "Adicionar aos favoritos",
      "openChat": "Abrir chat",
      "noFavorites": "Não tens contactos favoritos",
      "noFavoritesHint": "Marca contactos como favoritos para os veres aqui"
    },
    "connections": {
      "acceptSuccessTitle": "Conexão aceite",
      "acceptSuccessMessage": "Já podes conversar com este contacto.",
      "acceptErrorMessage": "Não foi possível aceitar o pedido.",
      "rejectSuccessTitle": "Pedido rejeitado",
      "rejectSuccessMessage": "Rejeitaste o pedido de conexão.",
      "rejectErrorMessage": "Não foi possível rejeitar o pedido.",
      "cancelSuccessTitle": "Pedido cancelado",
      "cancelSuccessMessage": "Cancelaste o pedido de conexão.",
      "cancelErrorMessage": "Não foi possível cancelar o pedido.",
      "viewRequests": "Ver pedidos",
      "dmBlockedTitle": "Conexão necessária",
      "dmBlockedMessage": "Aceita o pedido de conexão para conversar.",
      "alreadyPending": "Já existe um pedido pendente entre vocês.",
      "alreadyConnected": "Já estão conectados.",
      "cooldownActive": "Espera um pouco antes de voltar a enviar o pedido.",
      "rateLimited": "Muitos pedidos. Espera um momento e tenta novamente."
    },
    "search": "Pesquisar ou iniciar novo chat",
    "noRecentChats": "Sem chats recentes",
    "selectChat": "Seleciona um chat",
    "selectChatHint": "Escolhe uma conversa da lista para começar a conversar",
    "dm": {
      "deleteError": "Não foi possível eliminar o chat. Tenta novamente.",
      "deleteChat": "Eliminar chat",
      "deleting": "A eliminar..."
    }
  },
  "eventWizard": {
    "progressAria": "Wizard progress",
    "stepMeta": "Passo {current} de {total}",
    "sections": {
      "identity": "Identidade do evento",
      "visibility": "Visibilidade",
      "configuration": "Configuração",
      "storytelling": "Storytelling",
      "when": "Quando",
      "formatAndPlace": "Formato e local",
      "arrival": "Chegada",
      "speakers": "Palestrantes",
      "agenda": "Agenda",
      "branding": "Branding",
      "review": "Resumo",
      "discovery": "Descoberta"
    },
    "steps": {
      "basic": "Basics",
      "location": "Location",
      "speakers": "Speakers",
      "agenda": "Agenda",
      "style": "Style",
      "review": "Review"
    },
    "nav": {
      "prev": "Back",
      "next": "Next",
      "cancel": "Cancel",
      "draft": "Save draft",
      "publish": "Create event",
      "saveChanges": "Save changes",
      "saving": "Saving..."
    },
    "loading": "Loading event data...",
    "previewLive": "Live preview",
    "previewPlatform": "Platform preview",
    "edit": "Edit",
    "step1": {
      "title": "The essentials of your event",
      "description": "Give your event an attractive title, an inspiring description, and choose its type.",
      "titleLabel": "Event title",
      "titlePlaceholder": "E.g. Biavent Networking Night Madrid",
      "titleHint": "Be clear and descriptive. A good title grabs your target audience instantly.",
      "visibilityLabel": "Public or private?",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Private",
      "categoryLabel": "Main category",
      "eventTypeLabel": "Event type",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe what attendees will learn, why your event is unique, and who it is for...",
      "highlightLabel": "Highlight quote",
      "highlightPlaceholder": "E.g. 'The biggest meetup for developers and investors of the year.'",
      "highlightHint": "A short, powerful phrase highlighted on the event landing page.",
      "tipTitle": "💡 Biavent tip",
      "tipText": "85% of registrations are driven by a structured description and a concise title. Define your target audience well!"
    },
    "step2": {
      "title": "Location and date",
      "description": "Set the date, time, and whether the event is in person or online.",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "timePlaceholder": "E.g. 7:00 PM - 10:00 PM",
      "timezoneLabel": "Timezone",
      "locationLabel": "Location or link",
      "locationOnlineLabel": "Streaming link",
      "locationPlaceholder": "Street, city or link",
      "locationOnlinePlaceholder": "Zoom, Meet, YouTube...",
      "formatLabel": "Online or in person?",
      "formatInPerson": "In person",
      "formatOnline": "Online",
      "formatHybrid": "Hybrid",
      "mapButton": "Map",
      "venueLabel": "Venue name",
      "venuePlaceholder": "E.g. Main auditorium, Tech campus...",
      "arrivalLabel": "Additional arrival instructions",
      "arrivalPlaceholder": "Access, parking, floor, etc.",
      "mapsPreviewEmpty": "Enter an address to see the map preview",
      "capacityLabel": "Capacity limit",
      "capacityPlaceholder": "E.g. 100 — leave empty for unlimited",
      "capacityHint": "When capacity is reached, new registrations will be blocked automatically.",
      "latLabel": "Latitude (optional)",
      "lngLabel": "Longitude (optional)",
      "latPlaceholder": "E.g. 40.4167",
      "lngPlaceholder": "E.g. -3.7037"
    },
    "step3": {
      "title": "Your speakers",
      "description": "Introduce the speakers leading your sessions. Add role, bio, and photo.",
      "emptyTitle": "No speakers yet",
      "emptyText": "Will your event have speakers? Add them below. For informal networking you can skip this step.",
      "addSpeaker": "Add speaker",
      "nameLabel": "Name",
      "roleLabel": "Role",
      "bioLabel": "Short bio",
      "bioPlaceholder": "Short biography...",
      "avatarLabel": "Photo (URL)",
      "avatarPlaceholder": "https://...",
      "dragTitle": "Drag to reorder",
      "avatarUpload": "Upload photo",
      "avatarUploading": "Uploading...",
      "deleteSpeaker": "Remove"
    },
    "step4": {
      "title": "Program and agenda",
      "description": "Describe activities step by step so attendees can plan their day.",
      "emptyTitle": "Empty agenda",
      "emptyText": "Click «Add slot» to add activities (reception, talks, networking, etc.).",
      "addSlot": "Add slot",
      "startLabel": "Início",
      "endLabel": "Fim",
      "activityLabel": "Atividade",
      "deleteSlot": "Remover slot",
      "slotTitlePlaceholder": "Networking, talk...",
      "activityFallback": "Activity"
    },
    "step5": {
      "title": "Style and branding",
      "description": "Upload cover images, logos, and choose colors for cards and buttons.",
      "bannerLabel": "Cover / banner image",
      "bannerUpload": "Upload main image (1200×630)",
      "bannerUploading": "Uploading image...",
      "bannerRemove": "Remove cover",
      "bannerUrlHint": "Or paste an image URL:",
      "logoLabel": "Company / organizer logo",
      "logoUpload": "Upload logo",
      "logoUploading": "Uploading logo...",
      "logoRemove": "Remove logo",
      "logoUrlHint": "Or paste logo URL:",
      "typographyLabel": "Typography",
      "paletteLabel": "Event color palette",
      "paletteHint": "Pick a brand combination or customize the accent color.",
      "primaryColor": "Primary color",
      "accentColor": "Accent color (buttons)",
      "previewBadge": "UPCOMING",
      "previewCtaFallback": "Register"
    },
    "step6": {
      "title": "Review and publish",
      "description": "Add contact info, social links, and preview your landing before saving.",
      "websiteLabel": "Official website",
      "emailLabel": "Contact email",
      "mapsLabel": "Google Maps link",
      "socialLabel": "Social media (optional)",
      "ctaLabel": "Call-to-action button text",
      "ctaPlaceholder": "E.g. Register for the event",
      "ctaHint": "Text shown on the main registration button.",
      "reviewBasic": "Basics",
      "reviewLocation": "Location",
      "reviewSpeakers": "Speakers",
      "reviewAgenda": "Agenda",
      "reviewStyle": "Style",
      "noTitle": "No title",
      "toDefine": "To be defined",
      "speakersCount": "{{count}} speakers",
      "agendaCount": "{{count}} slots",
      "visualIdentity": "Visual identity",
      "withCover": "With cover",
      "withoutCover": "No cover"
    },
    "eventNew": {
      "title": "Create new event",
      "subtitle": "Follow the steps to publish on Biavent. It will be saved as a draft until you publish."
    },
    "errors": {
      "fixBeforeContinue": "Fix the errors before continuing to the next step.",
      "loadEvent": "Error loading event",
      "titleRequiredSave": "Please enter a title for your event",
      "fixStepBeforePublish": "Please fix the fields in Step {{step}} before publishing.",
      "invalidImage": "Please select a valid image file (png, jpg, jpeg)",
      "imageTooLarge": "Image size cannot exceed 5 MB",
      "uploadFailed": "Error uploading image",
      "draftUpdated": "Draft updated successfully",
      "eventUpdated": "Event updated successfully",
      "draftSaved": "Draft saved. You can edit and publish it later",
      "eventCreated": "Congratulations! The event was created successfully",
      "saveFailed": "Error saving"
    },
    "accordion": {
      "advancedLocation": "Advanced location",
      "capacity": "Capacity",
      "contact": "Contact and social (optional)"
    },
    "font": {
      "system": "System (default)",
      "serif": "Classic serif",
      "modern": "Modern sans"
    },
    "social": {
      "linkedinPlaceholder": "Your company LinkedIn URL",
      "twitterPlaceholder": "Twitter / X URL",
      "instagramPlaceholder": "Instagram URL"
    }
  },
  "dashboardPremium": {
    "greeting": "Welcome back, {name}",
    "contextSummary": "You have {events} events this week and {pending} pending to publish",
    "searchPlaceholder": "Search events…",
    "createEvent": "Create event",
    "viewAnalytics": "Analytics",
    "trendVsPrevious": "vs previous period",
    "kpiActiveEvents": "Active events",
    "kpiActiveEventsFooter": "{scheduled} scheduled · {live} live now",
    "kpiUsers": "Registered users",
    "kpiUsersFooter": "+{new} new this period",
    "kpiOrganizations": "Partner companies",
    "kpiOrgsFooter": "+{new} new this period",
    "kpiConversion": "Conversion",
    "kpiConversionFooter": "Registrations / users",
    "activityTitle": "Activity summary",
    "range7d": "7D",
    "range30d": "30D",
    "range90d": "90D",
    "seriesRegistrations": "Registrations",
    "seriesPublications": "Publications",
    "seriesConnections": "Connections",
    "chartEmpty": "No activity in this period yet",
    "upcomingTitle": "Upcoming events",
    "noUpcoming": "No upcoming events",
    "emptyUpcomingHint": "Crie um evento para vê-lo aqui quando estiver agendado.",
    "badgeLive": "LIVE",
    "badgeScheduled": "SCHEDULED",
    "badgeDraft": "DRAFT",
    "editEvent": "Edit",
    "viewAllUpcoming": "View all ({count}) →",
    "quickActionsTitle": "Quick actions",
    "performanceTitle": "Recent performance",
    "perfTopRegistrations": "Top registrations",
    "perfLowAttendance": "Lowest attendance",
    "perfTopOrgs": "Most active companies",
    "perfPendingTasks": "Pending tasks",
    "perfEmpty": "No data yet",
    "perfTasksEmpty": "No pending tasks",
    "taskDrafts": "{count} draft events",
    "taskUnpublished": "{count} upcoming drafts",
    "growthTitle": "Growth tips",
    "aiLabel": "AI recommendation",
    "growthTipDrafts": "Draft events don't generate registrations until you publish them.",
    "growthRecDrafts": "You have {count} draft(s). Publish at least one to start capturing attendees.",
    "growthTipCover": "Events with a professional cover image tend to convert better.",
    "growthRecCover": "Events with a cover image convert up to {percent}% better on average.",
    "growthTipAttendance": "Attendance is below your platform average.",
    "growthRecAttendance": "Current attendance rate is {rate}%. Send reminders before the event starts.",
    "growthTipDefault": "Keep publishing and engaging attendees after each event.",
    "growthRecDefault": "Review analytics after each event to double down on what works.",
    "feedTitle": "Recent activity",
    "feedEmpty": "No recent activity",
    "feedRegistration": "New registration",
    "feedPlatform": "Platform",
    "feedPublished": "Event published",
    "feedNewOrg": "New company",
    "loadError": "Could not load dashboard",
    "actionNewEventDesc": "Launch a new event in minutes",
    "actionNewOrgDesc": "Onboard a new partner company",
    "actionUsersDesc": "Manage users and roles",
    "actionPermissionsDesc": "Organizers and access",
    "actionNotificationsDesc": "Reach your audience",
    "actionAttendeesDesc": "Registrations and check-in",
    "actionAnalyticsDesc": "Networking and engagement",
    "actionExportDesc": "Export attendee data",
    "headerStatEventsWeek": "events this week",
    "headerStatPending": "pending to publish"
  },
  "notFound": {
    "title": "Página não encontrada",
    "message": "A página que procuras não existe ou já não está disponível.",
    "goHome": "Ir para eventos",
    "errorTitle": "Página não encontrada",
    "errorMessage": "Não foi possível carregar esta vista.",
    "reload": "Recarregar app"
  },
  "meetingQr": {
    "confirmTitle": "Confirmar encontro",
    "confirmWith": "Com {name}",
    "confirmCta": "Confirmar encontro",
    "scanCta": "Digitalizar QR",
    "scanTitle": "Digitalizar QR de encontro",
    "scanInstruction": "Aponte a câmara para o QR mostrado pela outra pessoa.",
    "scanHint": "Peça à outra pessoa para digitalizar este QR em Conexões → Digitalizar QR.",
    "generating": "A gerar QR seguro…",
    "expiresIn": "Expira em {time}",
    "confirmed": "Encontro confirmado!",
    "expired": "Este QR expirou",
    "generateAgain": "Gerar novo QR",
    "verifying": "A verificar…",
    "scanAgain": "Digitalizar novamente",
    "back": "Voltar",
    "badgeConfirmed": "Encontro confirmado",
    "errors": {
      "generic": "Algo correu mal. Tente novamente.",
      "invalid": "QR inválido",
      "expired": "Este QR expirou",
      "alreadyUsed": "Este QR já foi usado",
      "notTarget": "Este QR não é para si",
      "self": "Não pode confirmar um encontro consigo mesmo",
      "noConnection": "Precisam de estar ligados primeiro",
      "alreadyConfirmed": "Encontro já confirmado",
      "noPriorChat": "Precisam de ter conversado primeiro",
      "rateLimited": "Demasiadas tentativas. Aguarde um momento.",
      "camera": "Não foi possível aceder à câmara. Verifique as permissões.",
      "cameraDenied": "Permissão da câmara negada",
      "cameraUnavailable": "Nenhuma câmara encontrada neste dispositivo",
      "cameraInsecure": "A câmara requer uma ligação segura (HTTPS)"
    },
    "cameraPermissionTitle": "É preciso acesso à câmara",
    "cameraPermissionBody": "Para digitalizar o QR de encontro, a Biavent precisa usar a sua câmara. Toque no botão para permitir o acesso.",
    "allowCamera": "Permitir câmara e digitalizar",
    "requestingCamera": "A pedir acesso à câmara…",
    "cameraDeniedHint": "O acesso à câmara está bloqueado. Permita a câmara para a Biavent nas definições do navegador ou do telemóvel e tente novamente.",
    "tryAgain": "Tentar novamente"
  }
}
